import FormContainer from "../../../../components/formContainer/FormContainer";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import MultiSelect from "../../../../components/select/main/multi/MultiSelect";
import Select from "../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";

function AxisConfigPageView({
  configData,
  parkingLocations,
  onNameChange,
  onUrlChange,
  onUsernameChange,
  onPasswordChange,
  onAuthMethodChange,
  onAllowEmployeePlatesChange,
  onAllowVisitorPlatesChange,
  onParkingLocationsChange,
  onSubmit,
  onCancel,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="axis_configs_page_fetch">
      <FormContainer
        onSubmit={onSubmit}
        onCancel={onCancel}
        submitError={submitError}
        submitLoadingGroup={"axis_configs_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.name")}
            error={EVAApiHelper.getResponseError("name", submitError)}
            required
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.name")}
              value={configData.name}
              onChange={onNameChange}
            />
          </InputWrapper>
          <InputWrapper
            label={translate("eva.main.validation.attributes.url")}
            required
            error={EVAApiHelper.getResponseError("url", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.url")}
              value={configData.url}
              onChange={onUrlChange}
            />
          </InputWrapper>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.username")}
                required
                error={EVAApiHelper.getResponseError("username", submitError)}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.username",
                  )}
                  value={configData.username}
                  onChange={onUsernameChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.password")}
                required
                error={EVAApiHelper.getResponseError("password", submitError)}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.password",
                  )}
                  value={configData.password}
                  onChange={onPasswordChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <InputWrapper
            label={translate("eva.main.validation.attributes.auth_method")}
            required
            error={EVAApiHelper.getResponseError("auth_method", submitError)}
          >
            <Select
              value={configData.auth_method}
              options={[
                { value: "basic", label: "Basic" },
                { value: "digest", label: "Digest" },
              ]}
              onChange={onAuthMethodChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.parking_locations",
            )}
          >
            <MultiSelect
              value={configData.parking_locations}
              options={parkingLocations.map((location) => ({
                value: location.id,
                label: location.name,
              }))}
              onChange={onParkingLocationsChange}
            />
          </InputWrapper>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.allow_visitor_plates",
                )}
                required
              >
                <Select
                  value={configData.allow_visitor_plates}
                  options={[
                    { value: true, label: translate("eva.main.general.yes") },
                    { value: false, label: translate("eva.main.general.no") },
                  ]}
                  onChange={onAllowVisitorPlatesChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.allow_employee_plates",
                )}
                required
              >
                <Select
                  value={configData.allow_employee_plates}
                  options={[
                    { value: true, label: translate("eva.main.general.yes") },
                    { value: false, label: translate("eva.main.general.no") },
                  ]}
                  onChange={onAllowEmployeePlatesChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default AxisConfigPageView;
